import { StyledBroadsiderAssets } from './BroadsiderAssets.styled';
import { DownloadButton } from '../';
import { downloadFile } from '../../utils';

const BroadsiderAssets = ({ figure, onAvatavi = () => {}, onAr = () => {} }) => {
  return (
    <StyledBroadsiderAssets>
      <div className='bs-assets-content-wrapper'>
        <div className='bs-assets-content'>
          <div className='bs-assets-holder'>
            <div className='bs-assets-title-holder'>
              <img className='bs-assets-logo' src='/assets/controller_small.svg' />
              <div className='bs-assets-title'>Files</div>
            </div>
            <div className='bs-assets-buttons'>
              <DownloadButton disabled={!figure} onClick={() => downloadFile(figure.getAvatarImgSource(), 'avatar.png')}>
                <div className='bs-assets-download-button-content'>
                  <div className='bs-assets-download-button-image'>
                    <img src='/assets/avatar.png' style={{ opacity: '0.6' }}/>
                  </div>
                  <div className='bs-assets-download-button-text'>
                    <div>Profile Picture</div>
                    <div><span className='selected-text'>.png</span><span className='shadowed-text'>2048x2048</span></div>
                  </div>
                </div>
              </DownloadButton>
              <DownloadButton disabled={!figure || !figure.isReal()} onClick={() => downloadFile(figure.getFullImgSource(), 'full.png')}>
                <div className='bs-assets-download-button-content'>
                  <div className='bs-assets-download-button-image'>
                    <img src='/assets/full.png'/>
                  </div>
                  <div className='bs-assets-download-button-text'>
                    <div>Full View</div>
                    <div><span className='selected-text'>.png</span><span className='shadowed-text'>1200x1800</span></div>
                  </div>
                </div>
              </DownloadButton>
              <DownloadButton disabled={!figure || !figure.canDownloadVrm()} onClick={() => downloadFile(figure.getVrmSource(), 'model.vrm')}>
                <div className='bs-assets-download-button-content'>
                  <div className='bs-assets-download-button-image' style={{ padding: '5px' }}>
                    <img src='/assets/ar.svg' style={{ opacity: '0.8' }}/>
                  </div>
                  <div className='bs-assets-download-button-text'>
                    <div>3D Model</div>
                    <div><span className='selected-text'>.vrm</span></div>
                  </div>
                </div>
              </DownloadButton>
            </div>
          </div>
        </div>
      </div>
      <div className='bs-assets-corner bs-assets-corner-tl' />
      <div className='bs-assets-corner bs-assets-corner-tr' />
      <div className='bs-assets-corner bs-assets-corner-bl' />
      <div className='bs-assets-corner bs-assets-corner-br' />
    </StyledBroadsiderAssets>
  )
};

export default BroadsiderAssets;
